"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var jquery_1 = __importDefault(require("jquery"));
var hovo_api_1 = require("../../shared/hovo-api");
var form_1 = require("../../shared/form");
var messages_1 = require("../../shared/messages");
var config_1 = require("../../shared/config");
var http_1 = require("../../shared/http");
(0, jquery_1.default)(function () { return __awaiter(void 0, void 0, void 0, function () {
    var $form, userType, isTeacher_1, isStudent_1, data, _a, _i, _b, key, value, email, $addToStudentsList;
    return __generator(this, function (_c) {
        switch (_c.label) {
            case 0:
                $form = (0, jquery_1.default)('#mijn-gegevens-form');
                if (!$form.length) return [3 /*break*/, 5];
                userType = (0, hovo_api_1.getUserType)();
                isTeacher_1 = userType === "teacher";
                isStudent_1 = userType === "student";
                if (isTeacher_1) {
                    (0, jquery_1.default)('.only-student').hide();
                    $form.addClass('is-teacher');
                }
                else if (isStudent_1) {
                    $form.addClass('is-student');
                }
                if (!isTeacher_1) return [3 /*break*/, 2];
                return [4 /*yield*/, (0, hovo_api_1.getTeacherData)()];
            case 1:
                _a = _c.sent();
                return [3 /*break*/, 4];
            case 2: return [4 /*yield*/, (0, hovo_api_1.getStudentData)()];
            case 3:
                _a = _c.sent();
                _c.label = 4;
            case 4:
                data = _a;
                if (data) {
                    for (_i = 0, _b = Object.keys(data); _i < _b.length; _i++) {
                        key = _b[_i];
                        value = data[key];
                        if (value) {
                            (0, jquery_1.default)("input[name=\"".concat(key, "\"]")).val(value);
                        }
                    }
                    email = data.user.email;
                    (0, jquery_1.default)('select[name="gender"]').val(data.gender);
                    (0, jquery_1.default)('input[name="email"]').val(email);
                    (0, jquery_1.default)('input[name="repeatEmail"]').val(email);
                    $addToStudentsList = (0, jquery_1.default)('input[name="add_to_students_list"]');
                    if ($addToStudentsList.attr("type") === "checkbox") {
                        $addToStudentsList.prop('checked', data.add_to_students_list == 1);
                    }
                    else {
                        $addToStudentsList.val(data.add_to_students_list);
                    }
                    (0, jquery_1.default)('input[name="newsletter"]').prop('checked', data.newsletter == 1);
                    (0, jquery_1.default)('input[name="brochure"]').prop('checked', data.brochure == 1);
                    (0, jquery_1.default)('select[name="country"]').val(data.country);
                }
                $form.on('submit', function (event) {
                    return __awaiter(this, void 0, void 0, function () {
                        var request, valid, succeeded, extraMessages, url, response, url, response, json;
                        return __generator(this, function (_a) {
                            switch (_a.label) {
                                case 0:
                                    event.preventDefault();
                                    request = (0, form_1.convertFormToJSON)($form);
                                    valid = true;
                                    if (request.email && request.email !== request.repeatEmail) {
                                        valid = false;
                                        (0, messages_1.showErrorMessage)("Zorg ervoor dat u 2 keer het juiste e-mailadres intypt.");
                                    }
                                    if (!valid) return [3 /*break*/, 6];
                                    request.user = { email: request.email };
                                    delete request.email;
                                    request.add_to_students_list = request.add_to_students_list === "1";
                                    request.newsletter = request.newsletter === "1";
                                    request.brochure = request.brochure === "1";
                                    succeeded = false;
                                    extraMessages = "";
                                    if (!isTeacher_1) return [3 /*break*/, 2];
                                    url = "".concat((0, config_1.getApiRootUrl)(), "api/site/teacher");
                                    return [4 /*yield*/, (0, http_1.putJson)(url, request, (0, http_1.getHeaders)())];
                                case 1:
                                    response = _a.sent();
                                    succeeded = response.status === 200;
                                    return [3 /*break*/, 5];
                                case 2:
                                    if (!isStudent_1) return [3 /*break*/, 5];
                                    url = "".concat((0, config_1.getApiRootUrl)(), "api/site/student");
                                    return [4 /*yield*/, (0, http_1.putJson)(url, request, (0, http_1.getHeaders)())];
                                case 3:
                                    response = _a.sent();
                                    succeeded = response.status === 200;
                                    return [4 /*yield*/, response.json()];
                                case 4:
                                    json = _a.sent();
                                    extraMessages = json.errors ? Object.values(json.errors).flat(1).join('<br />') : '';
                                    _a.label = 5;
                                case 5:
                                    if (succeeded) {
                                        (0, messages_1.showSuccessMessage)("De gegevens zijn succesvol aangepast.");
                                        $form.find("input[type='submit']").prop('disabled', true);
                                    }
                                    else {
                                        (0, messages_1.showErrorMessage)("De gegevens konden niet aangepast worden." + (extraMessages ? "<br />".concat(extraMessages) : ""));
                                    }
                                    _a.label = 6;
                                case 6: return [2 /*return*/];
                            }
                        });
                    });
                });
                _c.label = 5;
            case 5: return [2 /*return*/];
        }
    });
}); });
